import React from 'react';
import { GiftIcon, HandIcon } from 'lucide-react';
import { bonuses, volumes } from '../data/content';
export function ProductIntro() {
  return <section className="bg-white px-4 py-6 text-center md:px-12 md:py-8" data-id="element-173" data-mp="22mq3uf51whbt">
      <h2 className="mx-auto max-w-[620px] text-[19px] font-extrabold uppercase leading-[1.2] tracking-[-0.2px] text-blue-950 md:text-[24px]" data-id="element-174" data-mp="1npfvvfrm9tku">
        The complete 6-in-1 pediatric OT intervention system
      </h2>
      <p className="mx-auto mt-1.5 max-w-[600px] text-[12px] font-bold uppercase leading-tight tracking-[0.04em] text-amber-700 md:text-[13px]" data-id="element-175" data-mp="2gdliy9657unu">
        Your complete collection includes
      </p>
      <div className="mt-3 grid gap-5 text-left sm:grid-cols-2 sm:gap-8" data-id="element-176" data-mp="26mh213wwpzqd">
        <div data-id="element-177" data-mp="2bl1uui9txh4s">
          <h4 className="flex items-center gap-1.5 text-[12px] font-extrabold uppercase tracking-[0.06em] text-teal-700 md:text-[13px]" data-id="element-178" data-mp="2bkimnt9ze73y">
            <HandIcon className="h-4 w-4" strokeWidth={2.5} aria-hidden data-id="element-179" data-mp="342e6picm2w7d" />
            The 6 main volumes
          </h4>
          <ol className="mt-2 space-y-1.5 text-[14px] leading-[1.35] text-slate-600 md:text-[15px]" data-id="element-180" data-mp="uf5i26155eht">
            {volumes.map(v => <li key={v.number} className="flex gap-2" data-id="element-181" data-mp="phx0o7nthehm">
                <span className="w-5 shrink-0 font-extrabold text-blue-950" data-id="element-182" data-mp="1458bg7c6cugo">{v.number}</span>
                <span data-id="element-183" data-mp="zf1nm9phldzh">{v.title}</span>
              </li>)}
          </ol>
        </div>
        <div data-id="element-184" data-mp="1d5wn4ve3iiqe">
          <h4 className="flex items-center gap-1.5 text-[12px] font-extrabold uppercase tracking-[0.06em] text-amber-700 md:text-[13px]" data-id="element-185" data-mp="1d5n5pw749jwb">
            <GiftIcon className="h-4 w-4" strokeWidth={2.5} aria-hidden data-id="element-186" data-mp="186jz47bhn5m8" />
            The 5 free bonuses
          </h4>
          <ol className="mt-2 space-y-1.5 text-[14px] leading-[1.35] text-slate-600 md:text-[15px]" data-id="element-187" data-mp="1n29pehnpi4wr">
            {bonuses.map(b => <li key={b.number} className="flex gap-2" data-id="element-188" data-mp="3ov7eq3i9yfcy">
                <span className="w-5 shrink-0 font-extrabold text-blue-950" data-id="element-189" data-mp="3oxtlw2196sun">{b.number}</span>
                <span data-id="element-190" data-mp="3jyh1rp1rnzvr">{b.title}</span>
              </li>)}
          </ol>
        </div>
      </div>

      <div className="mt-5 border-t border-slate-200 pt-3" data-id="element-191" data-mp="dhgnowr4lckw">
        <p className="text-[18px] font-extrabold uppercase leading-tight text-blue-950 md:text-[22px]" data-id="element-192" data-mp="hhqvmeyhad2e">
          11 professional resources. 440 pages.
        </p>
        <p className="mt-1 text-[12px] font-extrabold uppercase text-teal-700 md:text-[14px]" data-id="element-193" data-mp="revmgs39qwpj">
          One organized collection of practical intervention materials
        </p>
      </div>
    </section>;
}